// extracted by mini-css-extract-plugin
export default {"paymentMethodsEditModalContentWrapper":"PaymentMethodsEditModal_paymentMethodsEditModalContentWrapper__YaHhk","configTabContent":"PaymentMethodsEditModal_configTabContent__oQQpr"};